import LoadingSpinner from './LoadingSpinner';
import { CompositeComponent } from './types';
import { withPlaceholder } from './withPlaceholder';

export interface LoadingProps {
    loading: boolean;
    error?: any;
}

export default (LoadingSpinnerPlaceholder?: CompositeComponent<any>) =>
    withPlaceholder<LoadingProps>(
        LoadingSpinnerPlaceholder || LoadingSpinner,
        ({ loading }) => !!loading
    );



// WEBPACK FOOTER //
// ./src/client/components/withLoadingPlaceholder.tsx